<template>
  <div class="d-inline-block">
    <button @click="openQrCodeModal()" :class="['btn', btnSize, 'btn-circle', 'btn-info']" v-tooltip="$t('tooltip.openQrCode')"><i class="fa fa-qrcode"></i></button>
    <modal :name="`qr-modal-${componentId}`" :adaptive="true" height="auto">
      <div class="qr-wrapper">
        <div class="text-right p-2">
          <button type="button" class="btn btn-sm btn-light" @click="$modal.hide(`qr-modal-${componentId}`)" v-tooltip="$t('close')">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="p-3">
          <div class="d-flex align-center justify-content-center mb-3">
            <button class="qr-button" @click="download">
              <div :id="componentId"></div>
            </button>
          </div>
          <div class="text-center mb-3">
            <button :class="{'btn-success': size === 150}" class="btn btn-sm mr-1" @click="size = 150">150</button>
            <button :class="{'btn-success': size === 200}" class="btn btn-sm mr-1" @click="size = 200">200</button>
            <button :class="{'btn-success': size === 300}" class="btn btn-sm mr-1" @click="size = 300">300</button>
            <button :class="{'btn-success': size === 400}" class="btn btn-sm mr-1" @click="size = 400">400</button>
            <button :class="{'btn-success': size === 500}" class="btn btn-sm mr-1" @click="size = 500">500</button>
          </div>
          <div class="d-flex align-items-center justify-content-center mb-3">
            <label class="mb-0 mr-2 font-w600">{{ $t('color') }}</label>
            <input type="color" v-model="color" class="color-input">
          </div>
          <div class="text-center">
            <button @click="download" class="btn btn-info" v-tooltip="$t('tooltip.downloadQrCode')">
              <i class="fa fa-download mr-1"></i>{{ $t('tooltip.downloadQrCode') }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import QRCodeStyling from 'qr-code-styling'

export default {
  props: {
    name: {
      type: String,
      default: 'qr-code'
    },
    link: {
      type: String,
      default: ''
    },
    btnSize: {
      type: String,
      default: 'btn-sm'
    }
  },
  data (vm) {
    return {
      componentId: vm._uid,
      qrCode: null,
      size: 300,
      color: '#008078'
    }
  },
  watch: {
    size: 'bootQRcode',
    color: 'bootQRcode'
  },
  methods: {
    openQrCodeModal () {
      this.$modal.show('qr-modal-' + this.componentId)
      setTimeout(() => {
        this.bootQRcode()
      })
    },
    bootQRcode () {
      if (this.qrCode) {
        const svg = this.qrCode._container.getElementsByTagName('svg')[0]
        if (svg) svg.remove()
      }

      const qrCode = new QRCodeStyling({
        width: this.size,
        height: this.size,
        type: 'svg',
        data: this.link,
        dotsOptions: {
          color: this.color,
          type: 'extra-rounded'
        },
        backgroundOptions: {
          color: '#ffffff'
        }
      })

      this.qrCode = qrCode
      qrCode.append(document.getElementById(this.componentId))
    },
    download () {
      this.qrCode.download({ name: `qr-${this.name}-${this.size}`, extension: 'png' })
    }
  }
}
</script>

<style>
.qr-button {
  display: block;
  border: 0;
  background: none;
  cursor: pointer;
}
.color-input {
  width: 40px;
  height: 32px;
  padding: 2px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}
</style>
